/**
 * @flow
 */
'use strict';

import type { CodeDefinition } from '../Types';
import { occupationPrincipaleCodes } from './OccupationPrincipaleCodes';
import { occupationAutreCodes } from './OccupationAutreCodes';
import { raisonPrincipaleCodes } from './RaisonPrincipaleCodes';
import { raisonComplementaireCodes } from './RaisonComplementaireCodes';
import { santeOcculaire1Codes } from './SanteOcculaire1Codes';
import { santeOcculaire2Codes } from './SanteOcculaire2Codes';
import { santeMedicament1Codes } from './SanteMedicament1Codes';
import { santePosologie1Codes } from './SantePosologie1Codes';
import { santeGeneraleCodes } from './SanteGeneraleCodes';
import { santeMedicament2Codes } from './SanteMedicament2Codes';
import { santePosologie2Codes } from './SantePosologie2Codes';
import { santeFamilialeCodes } from './SanteFamilialeCodes';
import { santeParentCodes } from './SanteParentCodes';
import { santeAllergiesCodes } from './SanteAllergiesCodes';
import { filtreRougeCodes } from './FiltreRougeCodes';
import { stereo1Codes } from './Stereo1Codes';
import { stereo2Codes } from './Stereo2Codes';
import { deviationHCodes } from './DeviationHCodes';
import { deviationVCodes } from './DeviationVCodes';
import { dominanceCodes } from './DominanceCodes';
import { testEcranCodes } from './TestEcranCodes';
import { vision1Codes } from './Vision1Codes';
import { vision2Codes } from './Vision2Codes';
import { vision3Codes } from './Vision3Codes';
import { vision4Codes } from './Vision4Codes';
import { ophtalmoscopieCristalinCodes } from './OphtalmoscopieCristalinCodes';
import { ophtalmoscopieVitreCodes } from './OphtalmoscopieVitreCodes';
import { ophtalmoscopiePapillesCodes } from './OphtalmoscopiePapillesCodes';
import { ophtalmoscopieA_VCodes } from './OphtalmoscopieA_VCodes';
import { ophtalmoscopieMaculaCodes } from './OphtalmoscopieMaculaCodes';
import { ophtalmoscopieSPCodes } from './OphtalmoscopieSPCodes';
import { ophtalmoscopiePerCodes } from './OphtalmoscopiePerCodes';
import { biomicroscopieBLibresCodes } from './BiomicroscopieBLibresCodes';
import { biomicroscopieCPalpInfCodes } from './BiomicroscopieCPalpInfCodes';
import { biomicroscopieSupCodes } from './BiomicroscopieSupCodes';
import { biomicroscopieCBulbCodes } from './BiomicroscopieCBulbCodes';
import { biomicroscopieSclerCodes } from './BiomicroscopieSclerCodes';
import { biomicroscopieLimbeCodes } from './BiomicroscopieLimbeCodes';
import { biomicroscopieCorneeCodes } from './BiomicroscopieCorneeCodes';
import { biomicroscopieChAntCodes } from './BiomicroscopieChAntCodes';
import { biomicroscopieProfCodes } from './BiomicroscopieProfCodes';
import { biomicroscopieIrisCodes } from './BiomicroscopieIrisCodes';
import { biomicroscopieCristCodes } from './BiomicroscopieCristCodes';
import { gonioscopieChAntCodes } from './GonioscopieChAntCodes';
import { gonioscopiePapilleCodes } from './GonioscopiePapilleCodes';
import { gonioscopieEscPapCodes } from './GonioscopieEscPapCodes';
import { gonioscopieMaculaCodes } from './GonioscopieMaculaCodes';
import { gonioscopieCentraleCodes } from './GonioscopieCentraleCodes';
import { gonioscopieEquatCodes } from './GonioscopieEquatCodes';
import { gonioscopiePeriphCodes } from './GonioscopiePeriphCodes';
import { binoculaireSubjVLHCodes } from './BinoculaireSubjVLHCodes';
import { binoculaireSubjVPHCodes } from './BinoculaireSubjVPHCodes';
import { binoculaireSubjVLVCodes } from './BinoculaireSubjVLVCodes';
import { binoculaireSubjVPVCodes } from './BinoculaireSubjVPVCodes';
import { binoculaireObjVLCodes } from './BinoculaireObjVLCodes';
import { resumeTestCodes } from './ResumeTestCodes';
import { resumeVerificationCodes } from './ResumeVerificationCodes';
import { resumeResultatCodes } from './ResumeResultatCodes';
import { ocularSurgeryProcedureCodes } from './OcularSurgeryProcedureCodes';
import { vaScaleCodes } from './VAScaleCodes';
import { treatmentRecommendationCodes } from './TreatmentCodes';

export function initialiseUserCodes(codeDefinitions: [CodeDefinition]) : void {
  codeDefinitions.occupationPrincipaleCode = occupationPrincipaleCodes;
  codeDefinitions.occupationAutreCode = occupationAutreCodes;
  codeDefinitions.raisonPrincipaleCode = raisonPrincipaleCodes;
  codeDefinitions.raisonComplementaireCode = raisonComplementaireCodes;
  codeDefinitions.santeOcculaire1Code = santeOcculaire1Codes;
  codeDefinitions.santeOcculaire2Code = santeOcculaire2Codes;
  codeDefinitions.santeMedicament1Code = santeMedicament1Codes;
  codeDefinitions.santePosologie1Code = santePosologie1Codes;
  codeDefinitions.santeGeneraleCode = santeGeneraleCodes;
  codeDefinitions.santeMedicament2Code = santeMedicament2Codes;
  codeDefinitions.santePosologie2Code = santePosologie2Codes;
  codeDefinitions.santeFamilialeCode = santeFamilialeCodes;
  codeDefinitions.santeParentCode = santeParentCodes;
  codeDefinitions.santeAllergiesCode = santeAllergiesCodes;
  codeDefinitions.filtreRougeCode = filtreRougeCodes;
  codeDefinitions.stereo1Code = stereo1Codes;
  codeDefinitions.stereo2Code = stereo2Codes;
  codeDefinitions.deviationHCode = deviationHCodes;
  codeDefinitions.deviationVCode = deviationVCodes;
  codeDefinitions.dominanceCode = dominanceCodes;
  codeDefinitions.testEcranCode = testEcranCodes;
  codeDefinitions.vision1Code = vision1Codes;
  codeDefinitions.vision2Code = vision2Codes;
  codeDefinitions.vision3Code = vision3Codes;
  codeDefinitions.vision4Code = vision4Codes;
  codeDefinitions.ophtalmoscopieCristalinCode = ophtalmoscopieCristalinCodes;
  codeDefinitions.ophtalmoscopieVitreCode = ophtalmoscopieVitreCodes;
  codeDefinitions.ophtalmoscopiePapillesCode = ophtalmoscopiePapillesCodes;
  codeDefinitions.ophtalmoscopieA_VCode = ophtalmoscopieA_VCodes;
  codeDefinitions.ophtalmoscopieMaculaCode = ophtalmoscopieMaculaCodes;
  codeDefinitions.ophtalmoscopieSPCode = ophtalmoscopieSPCodes;
  codeDefinitions.ophtalmoscopiePerCode = ophtalmoscopiePerCodes;
  codeDefinitions.biomicroscopieBLibresCode = biomicroscopieBLibresCodes;
  codeDefinitions.biomicroscopieCPalpInfCode = biomicroscopieCPalpInfCodes;
  codeDefinitions.biomicroscopieSupCode = biomicroscopieSupCodes;
  codeDefinitions.biomicroscopieCBulbCode = biomicroscopieCBulbCodes;
  codeDefinitions.biomicroscopieSclerCode = biomicroscopieSclerCodes;
  codeDefinitions.biomicroscopieLimbeCode = biomicroscopieLimbeCodes;
  codeDefinitions.biomicroscopieCorneeCode = biomicroscopieCorneeCodes;
  codeDefinitions.biomicroscopieChAntCode = biomicroscopieChAntCodes;
  codeDefinitions.biomicroscopieProfCode = biomicroscopieProfCodes;
  codeDefinitions.biomicroscopieIrisCode = biomicroscopieIrisCodes;
  codeDefinitions.biomicroscopieCristCode = biomicroscopieCristCodes;
  codeDefinitions.gonioscopieChAntCode = gonioscopieChAntCodes;
  codeDefinitions.gonioscopiePapilleCode = gonioscopiePapilleCodes;
  codeDefinitions.gonioscopieEscPapCode = gonioscopieEscPapCodes;
  codeDefinitions.gonioscopieMaculaCode = gonioscopieMaculaCodes;
  codeDefinitions.gonioscopieCentraleCode = gonioscopieCentraleCodes;
  codeDefinitions.gonioscopieEquatCode = gonioscopieEquatCodes;
  codeDefinitions.gonioscopiePeriphCode = gonioscopiePeriphCodes;
  codeDefinitions.binoculaireSubjVLHCode = binoculaireSubjVLHCodes;
  codeDefinitions.binoculaireSubjVPHCode = binoculaireSubjVPHCodes;
  codeDefinitions.binoculaireSubjVLVCode = binoculaireSubjVLVCodes;
  codeDefinitions.binoculaireSubjVPVCode = binoculaireSubjVPVCodes;
  codeDefinitions.binoculaireObjVLCode = binoculaireObjVLCodes;
  codeDefinitions.resumeTestCode = resumeTestCodes;
  codeDefinitions.resumeVerificationCode = resumeVerificationCodes;
  codeDefinitions.resumeResultatCode = resumeResultatCodes;
  codeDefinitions.ocularSurgeryProcedureCodes = ocularSurgeryProcedureCodes;
  codeDefinitions.vaScaleCodes = vaScaleCodes;
  codeDefinitions.treatmentRecommendationCodes = treatmentRecommendationCodes;
}
